import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function SymptomSection() {
  return <section className="py-12" data-id="element-422">
      <div className="max-w-2xl mx-auto" data-id="element-423">
        <FadeIn data-id="element-424">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-10 relative overflow-hidden" data-id="element-425">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-400" data-id="element-426"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-427">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-red-100 text-red-600 text-lg mr-4" data-id="element-428">
                1
              </span>
              Bleeding Gums
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-429">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-430">
              <p data-id="element-431">
                If you've had gums that bleed ever since you can remember,
                you're not alone.
              </p>
              <p data-id="element-432">
                In fact, this is one of the first major signs of a biofilm
                crisis.
              </p>
              <p data-id="element-433">
                As biofilm accumulates, the bacteria inside release toxic
                enzymes that eat at your gum tissue around the clock.
              </p>
              <p data-id="element-434">
                When your immune system detects this attack, it sends white
                blood cells to fight back.
              </p>
              <p data-id="element-435">
                That battle — happening right at the gum line — is what causes
                the inflammation, the swelling, and eventually the bleeding.
              </p>
              <p data-id="element-436">And here's the cruel irony…</p>
              <p data-id="element-437">
                The harder you brush trying to fix it, the more you disturb the
                inflamed tissue.
              </p>
              <p data-id="element-438">Which only causes the bleeding to get worse.</p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-439">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-10 relative overflow-hidden" data-id="element-440">
            <div className="absolute top-0 left-0 w-2 h-full bg-orange-400" data-id="element-441"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-442">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 text-lg mr-4" data-id="element-443">
                2
              </span>
              Bad Breath
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-444">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-445">
              <p data-id="element-446">
                You already know the feeling of striking paranoia every time you
                talk to someone…
              </p>
              <p data-id="element-447">As isolating as that feels - you're not alone in this…</p>
              <p data-id="element-448">
                The reason why your breath smells - no matter what you do - is a
                major sign of a biofilm crisis.
              </p>
              <p data-id="element-449">
                See, the same bacteria inside biofilm feast on food particles
                and dead cells in your mouth.
              </p>
              <p data-id="element-450">
                As they digest, they release sulfur gases as waste — the same
                compounds responsible for the smell of rotten eggs.
              </p>
              <p className="font-[700]" data-id="element-451">
                Even though mouthwash masks it temporarily, the biofilm is still
                there.
              </p>
              <p data-id="element-452">
                In fact, mouthwash makes it even worse by getting rid of the one
                defense that naturally rids your teeth of biofilm - which I will
                reveal later.
              </p>
              <p data-id="element-453">
                Nonetheless, the bacteria are still feeding, and the gas keeps
                coming.
              </p>
              <p data-id="element-454">
                That's why no amount of mints, rinses, or tongue scraping ever
                fully solves bad breath.
              </p>
              <p data-id="element-455">
                In other words, you're treating the smell - and not the source…
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-456">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-10 relative overflow-hidden" data-id="element-457">
            <div className="absolute top-0 left-0 w-2 h-full bg-amber-400" data-id="element-458"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-459">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-amber-100 text-amber-600 text-lg mr-4" data-id="element-460">
                3
              </span>
              Cavities
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-461">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-462">
              <p data-id="element-463">
                Most people assume cavities come from what you eat or drink, but
                that's a common misconception.
              </p>
              <p data-id="element-464">
                While it may be true in some cases - the real culprit is biofilm
                sitting directly against your tooth surface.
              </p>
              <p data-id="element-465">
                See, since biofilm acts as a "protective layer" for the bad
                bacteria behind it…
              </p>
              <p data-id="element-466">
                This results in enamel-dissolving acid to be produced around the
                clock.
              </p>
              <p data-id="element-467">
                Even if you brush or use mouthwash - neither one dissolves this
                protective layer completely.
              </p>
              <p data-id="element-468">
                Which means it doesn't matter how little sugar you eat or how
                perfectly you brush…
              </p>
              <p data-id="element-469">
                Cavities will keep forming as a result of nothing being able to
                stop the production of these acids behind the biofilm…
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-470">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-10 relative overflow-hidden" data-id="element-471">
            <div className="absolute top-0 left-0 w-2 h-full bg-yellow-400" data-id="element-472"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-473">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-yellow-100 text-yellow-600 text-lg mr-4" data-id="element-474">
                4
              </span>
              Sensitivity
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-475">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-476">
              <p data-id="element-477">
                You know that sudden sharp jolt after a sip of cold water, hot
                tea, or even simply breathing through your mouth?
              </p>
              <p data-id="element-478">
                This is a result of the bacteria behind biofilm gradually
                exposing the nerves under your teeth.
              </p>
              <p data-id="element-479">
                And instead of addressing why it forms and wears down your
                enamel in the first place…
              </p>
              <p data-id="element-480">
                Anti-sensitivity toothpastes work by simply numbing these
                exposed nerves.
              </p>
              <p data-id="element-481">Essentially, acting like a 'mute button' for your mouth.</p>
              <p data-id="element-482">
                The good news is there is another solution to solve sensitive
                teeth for good.
              </p>
              <p data-id="element-483">
                One that actually heals your enamel and strengthens your gums.
              </p>
              <p data-id="element-484">
                Imagine ordering whatever you want at a restaurant — ice water,
                cold beer, ice cream — without mentally bracing yourself before
                every sip.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-485">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-10 relative overflow-hidden" data-id="element-486">
            <div className="absolute top-0 left-0 w-2 h-full bg-lime-400" data-id="element-487"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-488">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-lime-100 text-lime-600 text-lg mr-4" data-id="element-489">
                5
              </span>
              Yellow Teeth
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-490">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-491">
              <p data-id="element-492">
                Most people consider this "yellow teeth" - but this is another
                common misconception...
              </p>
              <p data-id="element-493">
                It's actually "yellow biofilm". And it's not a result of what
                you eat or drink.
              </p>
              <p data-id="element-494">That's right…</p>
              <p data-id="element-495">
                What we know as "yellow teeth" is a result of the bacteria
                hidden behind biofilm exposing the naturally yellow dentin
                underneath your enamel from the acids they produce.
              </p>
              <p data-id="element-496">
                In other words, "teeth whitening" strips won't cut it. And
                neither will brushing harder.
              </p>
              <p data-id="element-497">
                Because while they may temporarily work, they certainly do not
                address the root cause.
              </p>
              <p data-id="element-498">
                If you want whiter teeth, what you need to do is address the
                biofilm crisis head on.
              </p>
              <p data-id="element-499">
                Before I reveal how you can simply do this without an expensive
                visit to the dentist, there's one more sign that most people
                mistake for something else entirely.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-500">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 relative overflow-hidden" data-id="element-501">
            <div className="absolute top-0 left-0 w-2 h-full bg-emerald-400" data-id="element-502"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-503">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 text-lg mr-4" data-id="element-504">
                6
              </span>
              Receding Gums
            </h2>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-505">
              
            </div>
            <div className="editorial-text text-gray-700" data-id="element-506">
              <p data-id="element-507">
                If your gums keep receding despite trying everything - even a
                gum graft - here's why…
              </p>
              <p data-id="element-508">
                Similarly to how inflammation along your gumline is what causes
                your gums to bleed in the morning…
              </p>
              <p data-id="element-509">
                Gum recession is actually a result of this same inflammation
                never being turned off.
              </p>
              <p data-id="element-510">Why? It's not because your immune system is broken.</p>
              <p data-id="element-511">
                In fact, it's doing exactly what it's supposed to do - search
                for threats and eliminate them.
              </p>
              <p data-id="element-512">
                The problem is the bacteria hiding behind biofilm is invisible
                to your immune system.
              </p>
              <p data-id="element-513">
                And because your immune system can "sense" the bacteria, but
                can't actually eliminate it…
              </p>
              <p data-id="element-514">
                It's constantly stuck in "attack" mode with no end in sight.
              </p>
              <p data-id="element-515">
                And it's that chronic, relentless inflammation that slowly
                breaks down the gum tissue…
              </p>
              <p data-id="element-516">Pulling it away from your teeth millimeter by millimeter.</p>
              <p data-id="element-517">
                In other words, your gums aren't receding because of your
                genetics.
              </p>
              <p data-id="element-518">
                They're receding because they've been fighting a battle that
                never ends.
              </p>
              <p data-id="element-519">
                And that battle has one source - which you may be aware of by
                now.
              </p>
              <p data-id="element-520">
                The good news is once you finally get to the source - the battle
                stops not only stops…
              </p>
              <p data-id="element-521">
                But your gums finally get the chance to do what they were always
                capable of doing. Heal and regrow.
              </p>
              <p data-id="element-522">
                How do I know? Because that's how I've seen it play out in my
                own office for years…
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}